import { render, staticRenderFns } from "./PackingSlipCustomer.vue?vue&type=template&id=adaa0174&scoped=true&"
import script from "./PackingSlipCustomer.vue?vue&type=script&lang=js&"
export * from "./PackingSlipCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PackingSlipCustomer.vue?vue&type=style&index=0&id=adaa0174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaa0174",
  null
  
)

export default component.exports